var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.824219 0.770221C0.824219 0.487226 1.05363 0.257812 1.33663 0.257812H12.0118C12.2948 0.257812 12.5242 0.487226 12.5242 0.770221V9.73737C12.5242 10.0204 12.2948 10.2498 12.0118 10.2498H1.33663C1.05363 10.2498 0.824219 10.0204 0.824219 9.73737V0.770221ZM1.84904 1.28263V4.74139H4.24028V1.28263H1.84904ZM5.26509 1.28263V4.74139H8.08334V1.28263H5.26509ZM9.10816 1.28263V4.74139H11.4994V1.28263H9.10816ZM11.4994 5.76621H9.10816V9.22497H11.4994V5.76621ZM8.08334 9.22497V5.76621H5.26509V9.22497H8.08334ZM4.24028 9.22497V5.76621H1.84904V9.22497H4.24028Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.3a840bd9bb8a2f54e93a8171c0309a92.svg";
export { ForwardRef as ReactComponent };